import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BuddibleSocket, { MsgIDList } from "../../../lib/BuddibleSocket";

const socket = new BuddibleSocket();

export default function WrapperFavUserItem(props) {
  const {
    comp,
    i,
    searchWord,
    favUserListDropDown,
    isCreateGroupChat,
    selectGroupChatUser,
    checkSelectedUserChat,
    COMP_GB_TYPE,
    deleteFavUser,
    groupChatUserList,
  } = props;
  const compKey = comp.COMP_CD + "_" + i;

  const data = [...Object.values(comp.userList)];

  return (
    <div key={compKey}>
      <div className="p-2 mb-0 d-flex flex-row justify-content-between border-top">
        <div className="text-secondary font-weight-bold">
          [{COMP_GB_TYPE[comp.COMP_GB]}] {comp.COMP_NM}
        </div>
        <div className="cursor_pointer px-2">
          {comp.activeState ? (
            <i
              className="fas fa-chevron-up"
              onClick={() => {
                favUserListDropDown(comp.COMP_CD, false);
              }}
            />
          ) : (
            <i
              className="fas fa-chevron-down"
              onClick={() => {
                favUserListDropDown(comp.COMP_CD, true);
              }}
            />
          )}
        </div>
      </div>
      <div className={`chUser ${comp.activeState ? "" : "disabled"}`}>
        {data.map((user, index) => {
          if (
            !(
              user.USER_NICK.indexOf(searchWord) > -1 ||
              user.USER_ID.indexOf(searchWord) > -1
            )
          ) {
            return null;
          }

          const userKey =
            compKey + "_" + user.COMP_CD + "_" + user.USER_ID + "_" + index;
          return (
            <UserItem
              key={userKey}
              comp={comp}
              user={user}
              isCreateGroupChat={isCreateGroupChat}
              groupChatUserList={groupChatUserList}
              selectGroupChatUser={selectGroupChatUser}
              checkSelectedUserChat={checkSelectedUserChat}
              deleteFavUser={deleteFavUser}
            />
          );
        })}
      </div>
    </div>
  );
}

function UserItem(props) {
  const {
    comp,
    user,
    isCreateGroupChat,
    groupChatUserList,
    selectGroupChatUser,
    checkSelectedUserChat,
    deleteFavUser,
  } = props;
  const { t } = useTranslation();
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  let isSelected =
    groupChatUserList.findIndex((u) => u["USER_KEY"] === user["USER_KEY"]) > -1;
  let isOff = user.IS_OFF === "Y";
  let isTimeOn = user.IS_TIME_ON === "Y";
  let isOffTime = false;

  let TIME_START = user.TIME_START;
  let TIME_END = user.TIME_END;

  if (isTimeOn && TIME_START && TIME_END) {
    let date = new Date();
    let hour = date.getHours();
    let min = date.getMinutes();
    let sec = date.getSeconds();

    if (min < 10) min = "0" + min;
    if (sec < 10) sec = "0" + sec;

    let currentTime = `${hour}${min}${sec}`;

    currentTime = Number(currentTime);

    TIME_START = TIME_START.split(":").join("");
    TIME_START = Number(TIME_START);
    TIME_END = TIME_END.split(":").join("");
    TIME_END = Number(TIME_END);

    if (currentTime <= TIME_START || currentTime >= TIME_END) {
      isOffTime = true;
    }
  }

  function openUserDetailModal() {
    socket.fireLocalEventListener(
      MsgIDList.EVENT_FAV_USER_DETAIL_MODAL_CALL,
      "UserItem",
      { ...user, comp: comp }
    );
    setIsOpenMenu(false);
  }

  return (
    <>
      <div
        className={`d-flex flex-row justify-content-between cursor_pointer cursor_pointer_bg_light align-items-center px-2 py-1 mb-1 rounded ${
          isSelected ? "bg-blue-light" : ""
        }`}
      >
        <div
          className="d-flex flex-row justify-content-start align-items-center flex-fill"
          onClick={() => {
            if (user.USE_GB === "D") return;
            if (isCreateGroupChat) {
              selectGroupChatUser(user);
            } else {
              checkSelectedUserChat(comp, user);
            }
          }}
        >
          <div className="mr-2 position-relative">
            <div className="overflow-hidden">
              <div
                className="border"
                style={{
                  borderRadius: "45%",
                  width: 46,
                  height: 46,
                  background: `url(${user.USER_PIC}) #fff 50% 50%/cover no-repeat`,
                }}
              />
            </div>
            {(isOff || isOffTime) && (
              <div
                className="position-absolute bg-light text-secondary border d-flex flex-row justify-content-center align-items-center rounded-circle"
                style={{
                  top: 0,
                  left: 0,
                  width: 16,
                  height: 16,
                }}
              >
                <span className="font-size-06">
                  <i className="fa-solid fa-bell-slash" />
                </span>
              </div>
            )}
            {!(isOff || isOffTime) && Number(user.login_state) === 1 && (
              <div
                className={`position-absolute bg-info rounded-circle`}
                style={{
                  top: 3,
                  left: 3,
                  width: 10,
                  height: 10,
                }}
              />
            )}
          </div>
          <div className="font-weight-bold">
            <div>
              {user.USE_GB === "D" && (
                <span className="bg-danger text-white mr-1 px-2 rounded-pill">
                  {t("logiTalk.favList.favUser.secession")}
                </span>
              )}
              {user.USER_NICK || user.USER_NM}
            </div>
            <div className="text-secondary font-size-08">
              {user.USER_TEAM_NM ? `${user.USER_TEAM_NM}` : ""}
              {user.USER_TEAM_NM && user.USER_PART_NM && " | "}
              {user.USER_PART_NM ? `${user.USER_PART_NM}` : ""}
            </div>
          </div>
        </div>
        <div className="align-self-start text-secondary position-relative">
          <i
            className="fa-solid fa-ellipsis-vertical px-1 cursor_pointer"
            onClick={() => setIsOpenMenu(true)}
          />
          {isOpenMenu && (
            <div
              className="position-absolute bg-white rounded shadow-sm overflow-hidden"
              style={{ minWidth: 120, zIndex: 4, top: 0, right: 0 }}
            >
              <p
                className="p-2 cursor_pointer cursor_pointer_bg_light transition-1"
                data-toggle="modal"
                data-target="#UserDetailModal"
                onClick={openUserDetailModal}
              >
                {t("logiTalk.favList.favUser.showProfile")}
              </p>
              <p
                className="p-2 cursor_pointer cursor_pointer_bg_light transition-1"
                onClick={() => {
                  deleteFavUser(user);
                  setIsOpenMenu(false);
                }}
              >
                {t("logiTalk.favList.favUser.unfavorite")}
              </p>
            </div>
          )}
        </div>
      </div>

      {isOpenMenu && (
        <div
          className="vw-100 vh-100 position-fixed cursor_pointer"
          style={{
            top: 0,
            left: 0,
            zIndex: 3,
            background: "rgba(0,0,0,0.1)",
          }}
          onClick={() => setIsOpenMenu(false)}
        />
      )}
    </>
  );
}
